import { createContext, useContext } from 'react';

export type DrawerTab = 'overview' | 'notes' | 'transcript' | 'case-reports' | 'feedback';

export interface DrawerEditorContextValue {
  /** Switch the drawer from editor mode back to preview mode on the given tab. */
  exitToTab: (tab: DrawerTab) => void;
}

export const DrawerEditorContext = createContext<DrawerEditorContextValue | null>(null);

export function useDrawerEditor(): DrawerEditorContextValue | null {
  return useContext(DrawerEditorContext);
}
